module.exports = __webpack_public_path__ + "static/media/EXP.36832d0c.svg";